import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 3l10 18h-4l-10 -18l4 0","key":"svg-0"}],["path",{"d":"M5 3v18h4v-10.5","key":"svg-1"}],["path",{"d":"M19 21v-18h-4v10.5","key":"svg-2"}]]

const IconBrandNetflix = createReactComponent('outline', 'brand-netflix', 'BrandNetflix', __iconNode);

export default IconBrandNetflix;